export type ProcessStep = {
  title: string;
  description: string;
  duration: string;
};

export const processSteps: ProcessStep[] = [
  {
    title: 'Discovery',
    description: 'We discuss the problem, review references, and map risks. Complex builds kick off with a paid discovery sprint.',
    duration: '2 to 3 days'
  },
  {
    title: 'Design & Proofing',
    description: 'I translate research into CAD, tooling concepts, or cable specs and share early proofs before cutting chips.',
    duration: '1 to 2 weeks'
  },
  {
    title: 'Build & Validate',
    description: 'Fabricate parts, cable assemblies, or jigs, then measure, test, and adjust until it performs.',
    duration: '1 to 3 weeks'
  },
  {
    title: 'Deliver & Support',
    description: 'Hand off the hardware, build documentation, and support additional runs or iterations.',
    duration: 'ongoing'
  }
];
